/* eslint-disable import/no-anonymous-default-export */
let detectLoudnessTimer = -1;
let turnMuteIndicationOffTimer = -1;
let muteIndication = false;
const loudnessDetector = {};
export default {
	/**
	 * This function turns the muted indication off and clear the timeouts.
	 */
	turnMuteIndicationOff() {
		clearTimeout(detectLoudnessTimer);
		clearTimeout(turnMuteIndicationOffTimer);
		turnMuteIndicationOffTimer = -1;
		muteIndication = false;
	},

	async turnLoudnessDetectorOn({
		selectedMicrophoneId,
		isAudioEnabled,
		indicator,
	}: {
		selectedMicrophoneId: string;
		isAudioEnabled: boolean;
		indicator: React.MutableRefObject<undefined>;
	}) {
		try {
			// Create Audio Context from Mic  https://developer.mozilla.org/en-US/docs/Web/API/AudioContext
			loudnessDetector.audioContext = new AudioContext();
			loudnessDetector.stream = await navigator.mediaDevices.getUserMedia({
				audio: {
					deviceId: selectedMicrophoneId,
				},
			});

			loudnessDetector.source =
				loudnessDetector.audioContext.createMediaStreamSource(
					loudnessDetector.stream
				);
			loudnessDetector.analyser =
				loudnessDetector.audioContext.createAnalyser();

			loudnessDetector.source.connect(loudnessDetector.analyser);

			// https://developer.mozilla.org/en-US/docs/Web/API/BaseAudioContext/createAnalyser
			loudnessDetector.analyser.fftSize = 2048;
			const bufferLength = loudnessDetector.analyser.fftSize;
			const timeDomainData = new Uint8Array(bufferLength);

			const detectLoudness = () => {
				// Keep running only if audio is not enabled and we have a valid analyser

				if (
					!isAudioEnabled ||
					!loudnessDetector.analyser ||
					!indicator.current
				) {
					return;
				}
				// Only process the audio if the tab is visible and the popup was not recently dismissed
				// if (document.visibilityState === 'visible') {
				loudnessDetector.analyser.getByteTimeDomainData(timeDomainData);

				let max = 0;
				for (let index = timeDomainData.length - 1; index >= 0; index -= 1) {
					max = Math.max(max, Math.abs(timeDomainData[index] - 128));
				}
				indicator.current.style.width = `${max}%`;

				detectLoudnessTimer = setTimeout(detectLoudness, 200);
			};

			detectLoudness();
		} catch (e) {
			// An error has occured, we don't want to bother the user, the only affect
			// is, the user won't see the mute indication
		}
	},

	turnLoudnessDetectorOff() {
		// Check if we have a valid loudnessDetector object before destroying it
		if (loudnessDetector.analyser) {
			loudnessDetector.analyser.disconnect();
			loudnessDetector.source.disconnect();
			loudnessDetector.stream
				.getTracks()
				.forEach((track: { stop: () => any }) => track.stop());
			loudnessDetector.audioContext.close();
			loudnessDetector.analyser = null;
			loudnessDetector.source = null;
			loudnessDetector.stream = null;
			loudnessDetector.audioContext = null;
		}
		this.turnMuteIndicationOff();
	},
};
